import Currency from "../currency";
import Entity from "../entity";
import AuxiliaryService from "./auxiliaryService";

export default class WebServiceMarkup extends Entity<number> {
  serviceId: number;
  service: AuxiliaryService;
  fromAirportId?: string;
  toAirportId?: string;
  markup: number;
  calculationType: number;
  currencyId: string;
  currency: Currency;
  isDefault: boolean;
  isDeleted: boolean;
  deleterUserId: any;
  deletionTime: any;
  lastModificationTime?: string;
  lastModifierUserId?: number;
  creationTime: string;
  creatorUserId?: number;

}
interface Service {
  name: string;
  isActive: boolean;
  id: string;
}
